import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { toast } from 'sonner';
import { isAxiosError } from 'axios';
import i18next from '@/i18next';
export const cn = (...inputs) => twMerge(clsx(inputs));
const readString = (data, key) => {
    if (typeof data !== 'object' || data === null) {
        return undefined;
    }
    const value = data[key];
    return typeof value === 'string' && value.trim() !== '' ? value : undefined;
};
export const errorHandler = (error) => {
    // Controllers answer `{ message }`, the documented API shape is `{ error }`,
    // and an unhandled 500 carries neither (or an HTML page) — so fall through
    // to the generic copy rather than toasting an empty string.
    const data = isAxiosError(error) ? error.response?.data : undefined;
    const message = readString(data, 'message') ?? readString(data, 'error') ?? i18next.t('occurred', { ns: 'error' });
    toast.error(message, { description: readString(data, 'description') });
};
